import { useEffect } from 'react';

import useBrandName from './useBrandName';

/**
 * Call `useDocumentTitle` in the component that owns the final page-title value:
 * the page root for static routes, or a detail layout / single detail page when
 * the tab title comes from fetched data. `useNavTitle` still controls the left-nav
 * label and may differ from the browser tab in nested detail flows. Do not put
 * this hook in generic layout primitives (`PageLayout`, etc.).
 */
const useDocumentTitle = (title?: string) => {
	const brandName = useBrandName();

	useEffect(() => {
		document.title = title ? `${title} - ${brandName}` : brandName;
	}, [title, brandName]);
};

export default useDocumentTitle;
